<app-si-dialog modalBodyClasses="flex flex-col h-full w-full overflow-hidden p-4 min-h-[200px]" header="Export to Zoho">
	<ng-template appDialogBody>
		<ng-container *ngIf="accuracyTier">
			<div class="mb-4 text-center rounded-md border border-warning bg-warning-container text-dark px-4 py-3 text-sm">{{accuracyTierText}}</div>
		</ng-container>

		<div class="flex flex-col overflow-hidden">
			<div *ngIf="isBusy" class="mt-12">
				<div class="flex flex-wrap -mx-2">
					<div class="w-full sm:flex-none sm:w-5/6 sm:ml-[8.333333%] text-center px-2">
						<b>{{busyLabel}}</b><br />
						{{busySublabel}}
					</div>
				</div>
			</div>

			<div class="pt-6" *ngIf="currentPage === pages.loading && !isBusy">
				<div class="flex justify-center pt-6">
					<mat-spinner></mat-spinner>
				</div>
			</div>
			<!---contacts start-->
			<ng-container *ngIf="currentPage === pages.exportType && !isBusy">
				<h3>Export Type</h3>
				Select how you want to export the selected contacts.
				<br /><br />
				<div class="table-scroll">
					<table class="si-table si-table--striped si-table--hover si-table--grid">
						<thead>
						<tr>
							<th class="flex-none w-full px-2">
								Export Type
							</th>
						</tr>
						</thead>
						<tbody>
						<tr>
							<td class="pt-2 pb-2" (click)="setExportType('lead')">
								Export as Lead
							</td>
						</tr>
						<tr>
							<td class="pt-2 pb-2" (click)="setExportType('contact')">
								Export as Contact
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</ng-container>

			<ng-container *ngIf="currentPage === pages.leadOwner && !isBusy">
				<h3>{{ exportType | titlecase }} Owner (optional)</h3>
				Select a {{ exportType | lowercase}} owner for the selected contacts. This is optional.
				<br /><br />
				<div class="flex-none w-full pl-0 pr-0">
					<mat-form-field appearance="outline" class="mb-1 w-full no-padding">
						<mat-label>Filter by name or email</mat-label>
						<input matInput type="text" placeholder="Filter by name or email"
							   [(ngModel)]="filterLeadOwner" aria-describedby="basic-addon1">
						<fa-icon class="mat-primary si-icon" matPrefix [icon]="['fal', 'magnifying-glass']"></fa-icon>
					</mat-form-field>
				</div>

				<div class="table-scroll">
					<table class="table-fixed si-table si-table--striped si-table--hover si-table--grid">
						<thead>
						<tr>
							<th class="flex-none w-1/2 px-2">
								Name
							</th>
							<th class="flex-none w-5/12 px-2">
								Email
							</th>
							<th *ngIf="(leadOwners | filter: filterLeadOwner).length > 0" class="flex-none w-1/12 px-2">
								&nbsp;
							</th>
						</tr>
						</thead>
						<tbody>
						<tr (click)="selectLeadOwner(leadowner.id)"
							*ngFor="let leadowner of leadOwners | filter: filterLeadOwner | orderBy : 'name'">
							<!-- | filter:term -->
							<td class="flex-none w-1/2 px-2">{{ leadowner.name }}</td>
							<td class="flex-none w-5/12 px-2">{{ leadowner.email }}</td>
							<td class="flex-none w-1/12 text-center px-0">
								<fa-icon [hidden]="leadowner.id !== selectedLeadOwner" class="py-0" [icon]="['fas', 'check']"></fa-icon>
							</td>
							<!--<td>{{ leadowner.type }}</td>-->
						</tr>
						<tr *ngIf="(leadOwners | filter: filterLeadOwner).length === 0">
							<td colspan="2" class="flex-none w-full text-center bg-white py-6 px-2">
								<i>No {{ exportType}} Owners Found</i>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</ng-container>

			<ng-container *ngIf="currentPage === pages.campaign && !isBusy">
				<h3>Campaigns (optional)</h3>
				Select one or more campaigns you want to assign the selected contacts to. This is optional.
				<br /><br />
				<div class="flex-none w-full pl-0 pr-0">
					<mat-form-field appearance="outline" class="mb-1 w-full no-padding">
						<mat-label>Filter by name</mat-label>
						<input matInput type="text" placeholder="Filter by name"
							   [(ngModel)]="filterCampaigns" aria-describedby="basic-addon1">
						<fa-icon class="mat-primary si-icon" matPrefix [icon]="['fal', 'magnifying-glass']"></fa-icon>
					</mat-form-field>
				</div>
				<div class="table-scroll">
					<table class="table-fixed si-table si-table--striped si-table--hover si-table--grid">
						<thead>
						<tr>
							<th class="w-full sm:flex-none sm:w-5/6 px-2">
								Name
							</th>
							<th class="w-full sm:flex-none sm:w-1/6 px-2">
								&nbsp;
							</th>
						</tr>
						</thead>
						<tbody>
						<tr (click)="selectCampaign(campaign.id)"
							*ngFor="let campaign of campaigns | filter : filterCampaigns | orderBy : 'name'">
							<td class="w-full sm:flex-none sm:w-5/6 px-2">{{ campaign.name }}</td>
							<td class="w-full sm:flex-none sm:w-1/6 text-center px-0">
								<fa-icon [hidden]="!isCampaignSelected(campaign.id)" class="py-0" [icon]="['fas', 'check']"></fa-icon>
							</td>
						</tr>
						<tr *ngIf="(campaigns | filter: filterCampaigns).length === 0">
							<td colspan="2" class="w-full sm:flex-none sm:w-full text-center bg-white py-6 px-2"><i>No
								Campaigns
								Found</i></td>
						</tr>
						</tbody>
					</table>
				</div>
			</ng-container>

			<ng-container *ngIf="data?.company && currentPage === pages.duplicates && !isBusy">
				<h3>Duplicates</h3>
				<div class="flex flex-wrap -mx-2">
					<div class="flex-none w-1/2 px-2">
						<b>Found {{ duplicateCompanyCount }} duplicate<span *ngIf="duplicateCompanyCount != 1">s</span>:</b>
					</div>
					<div class="flex-none w-1/2 label-group px-2">
						<b>Resolve Duplicates by:</b>
					</div>
				</div>
				<div class="flex flex-wrap -mx-2 mt-2">
					<div class="flex-none w-1/2 table-scroll px-2">
						<table class="table-fixed si-table si-table--hover si-table--grid">
							<tbody>
							<tr *ngFor="let match of duplicateCompanyMatchIds ">
								<td class="flex-none w-full px-2">{{ match.companyName }}</td>
							</tr>
							</tbody>
						</table>
					</div>
					<div class="flex-none w-1/2 px-2">
						<app-duplicate-resolution-radio-group [(ngModel)]="duplicateResolution"></app-duplicate-resolution-radio-group>
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="data?.contacts && currentPage === pages.duplicates && !isBusy">
				<h3>Duplicates</h3>
				<div class="flex flex-wrap -mx-2">
					<div class="flex-none w-1/2 px-2">
						<b>Found {{ duplicateCount }} duplicate<span *ngIf="duplicateCount != 1">s</span>:</b>
					</div>
					<div class="flex-none w-1/2 label-group px-2">
						<b>Resolve Duplicates by:</b>
					</div>
				</div>
				<div class="flex flex-wrap -mx-2 mt-2">
					<div class="flex-none w-1/2 table-scroll px-2">
						<table class="table-fixed si-table si-table--hover si-table--grid">
							<tbody>
							<tr *ngFor="let match of duplicateMatchIds ">
								<td class="flex-none w-full px-2">{{ match.contactName }}
								</td>
							</tr>
							</tbody>
						</table>
					</div>
					<div class="flex-none w-1/2 px-2">
						<app-duplicate-resolution-radio-group [(ngModel)]="duplicateResolution"></app-duplicate-resolution-radio-group>
					</div>
				</div>
			</ng-container>
			<!---contacts ends-->

			<!---company starts-->
			<ng-container *ngIf="data?.company && currentPage === pages.exportFinished && !isBusy">
                <ng-container *ngIf="exportedCompanyCount > 0 && failedCompany.length !== exportedCompanyCount; else companyFailedHeader">
					<h3>Export Succeeded</h3>
				</ng-container>
				<ng-template #companyFailedHeader>
					<h3>Export Failed</h3>
				</ng-template>
				<div class="flex flex-wrap -mx-2">
					<div class="flex-none w-full px-2" *ngIf="failedCompany.length === 0">
						You have successfully exported {{exportedCompanyCount}}
						<span *ngIf="exportedCompanyCount === 1">company </span>
						<span *ngIf="exportedCompanyCount !== 1">companies </span>
						to Zoho.
					</div>

                    @if (failedCompany.length > 0) {
                        <div class="flex-none w-full px-2">
                            <p>For {{failedCompany.length}} company couldn't be updated. This could be caused
                                by the Zoho DuplicateChecker or because SalesIntel is not allowed to create new Accounts in
                                your Zoho instance.</p>

                            <div class="table-scroll">
                                <table class="table-fixed si-table si-table--hover">
                                    @for (failedComp of failedCompany; track failedComp) {
                                        <tr>
                                            <td class="flex-none w-full text-danger px-2">
                                                Failed export <strong>{{failedComp.companyName}}</strong>: {{failedComp.message}}
                                            </td>
                                        </tr>
                                    }
                                </table>
                            </div>
                        </div>
                    }
				</div>
			</ng-container>

			<!--company end-->

			<!---contacts start-->
			<ng-container *ngIf="data?.contacts && currentPage === pages.exportFinished && !isBusy">
                <ng-container *ngIf="exportedContactCount > 0 && failedContacts.length !== exportedContactCount; else contactFailedHeader">
					<h3>Export Succeeded</h3>
				</ng-container>
				<ng-template #contactFailedHeader>
					<h3>Export Failed</h3>
				</ng-template>
				<!-- Exporting without conversion issues -->
				<div *ngIf="exportedContactCount > failedContacts.length && (duplicateResolution === 'skip' || (exportType.toLowerCase() === 'contact' && duplicateLeadsCount === 0) || (exportType.toLowerCase() === 'lead' && duplicateContactsCount === 0))">
					You have successfully exported {{(exportedContactCount - failedContacts.length)}}
					<span *ngIf="(exportedContactCount - failedContacts.length) === 1">contact as a {{ exportType | lowercase }}</span>
					<span *ngIf="(exportedContactCount - failedContacts.length) !== 1">contacts as {{ exportType | lowercase }}s</span> to
					Zoho.
				</div>


				<div *ngIf="exportType.toLowerCase() === 'contact' && duplicateLeadsCount > 0 && duplicateResolution !== 'skip'">
					<div *ngIf="exportedContactCount > duplicateLeadsCount + failedContacts.length">
						You have successfully exported {{(exportedContactCount - duplicateLeadsCount - failedContacts.length)}}
						<span *ngIf="(exportedContactCount - duplicateLeadsCount - failedContacts.length) === 1">contact as a
							{{ exportType | lowercase }}</span>
						<span *ngIf="(exportedContactCount - duplicateLeadsCount - failedContacts.length) != 1">contacts as
							{{ exportType | lowercase }}s</span> to Zoho.
						<br /><br />
					</div>
				</div>

				<div *ngIf="exportType.toLowerCase() === 'lead' && duplicateContactsCount > 0 && duplicateResolution !== 'skip'">
					<div *ngIf="exportedContactCount > duplicateContactsCount + failedContacts.length">
						You have successfully exported {{(exportedContactCount - duplicateContactsCount - failedContacts.length)}}
						<span *ngIf="(exportedContactCount - duplicateContactsCount - failedContacts.length) === 1">contact as a
							{{ exportType | lowercase }}</span>
						<span *ngIf="(exportedContactCount - duplicateContactsCount - failedContacts.length) != 1">contacts as
							{{ exportType | lowercase }}s</span> to Zoho.
						<br /><br />
					</div>
				</div>

				<mat-accordion class="pt-1">
					<!-- Exporting as contact, but already few exist as lead -->
					<mat-expansion-panel *ngIf="exportType.toLowerCase() === 'contact' && duplicateLeadsCount > 0 && duplicateResolution !== 'skip'">
						<mat-expansion-panel-header>
							<div>
								For {{duplicateLeadsCount}} contact<span *ngIf="duplicateLeadsCount != 1">s</span> we found a duplicate lead in Zoho. We updated
								<ng-container *ngIf="duplicateLeadsCount === 1">that lead</ng-container>
								<ng-container *ngIf="duplicateLeadsCount !== 1">those leads</ng-container> as we cannot automatically
								convert leads into contacts. Please login to the Zoho portal to manually convert below lead
								<ng-container *ngIf="duplicateLeadsCount != 1">s</ng-container> into contacts.
							</div>
						</mat-expansion-panel-header>
						<ng-template matExpansionPanelContent>
							<div class="table-scroll">
								<table class="si-table si-table--hover">
									<tbody class="duplicate-container">
									<tr *ngFor="let lead of duplicateLeadsMatchIds">
										<td class="flex-none w-full text-left text-danger px-2">
											<b>{{lead.contactName}}</b> at {{lead.companyName}} found as Lead
										</td>
									</tr>
									</tbody>
								</table>
							</div>
						</ng-template>
					</mat-expansion-panel>
					<!-- Duplicate API(Exporting as lead, but already few exist as contact) -->
					<mat-expansion-panel *ngIf="exportType.toLowerCase() === 'lead' && duplicateContactsCount > 0 && duplicateResolution !== 'skip'">
						<mat-expansion-panel-header>
							For below {{duplicateContactsCount}} contact
							<ng-container *ngIf="duplicateContactsCount !== 1">s</ng-container> we found an existing contact in Zoho. We updated
							<ng-container *ngIf="duplicateContactsCount === 1">that contact</ng-container>
							<ng-container *ngIf="duplicateContactsCount !== 1">those contacts</ng-container> as we cannot convert contacts back into leads.
						</mat-expansion-panel-header>
						<ng-template matExpansionPanelContent>
							<div class="table-scroll">
								<table class="duplicate-contacts si-table si-table--hover">
									<tbody class="duplicate-container">
									<tr *ngFor="let contact of duplicateContactsMatchIds">
										<td class="flex-none w-full text-left text-danger px-2">
											<b>{{contact.contactName}}</b> at {{contact.companyName}} found as Contact
										</td>
									</tr>
									</tbody>
								</table>
							</div>
						</ng-template>
					</mat-expansion-panel>
					<!-- Export API(Exporting as lead, but already few exist as contact) -->
                    @if (failedContacts.length > 0) {
                        <div class="flex-none w-full px-2">
                            <p>For {{failedContacts.length}} contact@if (failedContacts.length != 1) {s}
                                the connected account couldn't be updated. This could be caused by the Zoho DuplicateChecker
                                or because SalesIntel is not allowed to create new Accounts in your Zoho instance.</p>

                            <div class="table-scroll">
                                <table class="table-fixed si-table si-table--hover">
                                    @for (failedContact of failedContacts; track failedContact) {
                                        <tr>
                                            <td class="flex-none w-full text-danger px-2">
                                                Failed export <strong>{{failedContact.contactName}}</strong> at
                                                {{failedContact.companyName}}: {{failedContact.message}}
                                            </td>
                                        </tr>
                                    }
                                </table>
                            </div>
                        </div>
                    }
					<!-- Failed exports -->
					<mat-expansion-panel *ngIf="duplicateFailedContacts.length > 0">
						<mat-expansion-panel-header>
							<div>However {{duplicateFailedContacts.length}} contact
								<ng-container *ngIf="duplicateFailedContacts.length != 1">s</ng-container>
								couldn't be exported, most likely because the Zoho DuplicateChecker detected it as a
								duplicate. We suggest you import the failed contacts manually into Zoho.
							</div>
						</mat-expansion-panel-header>
						<ng-template matExpansionPanelContent>
							<div class="table-scroll">
								<table class="failCount-contacts si-table si-table--hover">
									<tbody>
									<tr *ngFor="let dFContacts of duplicateFailedContacts">
										<td class="flex-none w-full text-danger px-2">Exporting
											<b>{{dFContacts.contactName}}</b> at {{dFContacts.companyName}}
									</tr>
									</tbody>
								</table>
							</div>
						</ng-template>
					</mat-expansion-panel>
				</mat-accordion>
			</ng-container>

			<ng-container *ngIf="data?.contacts">
				<div *ngIf="currentPage === pages.exportEmpty && !isBusy">
					<div class="text-center">
						<h3>Nothing to Export</h3>
						All selected contacts are duplicates and you decided to skip duplicates, so there's nothing left to
						export.
					</div>
				</div>
				<div *ngIf="currentPage === pages.exportFailed && !isBusy">
					<div>
						<h3>Export Failed</h3>
						Your export failed with the following error: <br /><br />
						<pre class="text-danger" style="max-height: 200px; white-space: pre-wrap;">{{exportError}}</pre><br />
						Please resolve the problem in your Zoho instance and retry or contact SalesIntel support at <a
							href="mailto:support@salesintel.io">support&#64;salesintel.io</a>.
					</div>
				</div>
			</ng-container>
			<!---contacts ends-->

			<!---company starts-->
			<ng-container *ngIf="data?.company">
				<section class="text-center" *ngIf="currentPage === pages.exportEmpty && !isBusy">
					<h3>Nothing to Export</h3>
					All selected company are duplicates and you decided to skip duplicates, so there's nothing left to export.
				</section>

				<section class="text-center" *ngIf="currentPage === pages.exportFailed && !isBusy">
					<h3>Export Failed</h3>
					Your export failed with the following error:
					<pre class="text-danger" style="max-height: 200px; white-space: pre-wrap;">{{exportError}}</pre><br />
					Please resolve the problem in your Zoho instance and retry or contact SalesIntel support at <a
						href="mailto:support@salesintel.io">support&#64;salesintel.io</a>.
				</section>
			</ng-container>
		</div>
	</ng-template>

	<ng-template appDialogFooter>
		<div>
			<button matButton="outlined" type="button" *ngIf="showCancelButton && !isBusy" (click)="onClose()">Cancel</button>
		</div>
		<div>
			<button matButton="outlined" type="button" class="mr-2" *ngIf="showPreviousButton && !isBusy"
					(click)="onPrevious()">Previous</button>
			<button matButton="filled" type="button" *ngIf="showNextButton && !isBusy" (click)="onNext()">Next</button>
			<button matButton="filled" type="button" *ngIf="showRetryButton" (click)="onRetryExport()">Retry</button>
			<button matButton="outlined" type="button" *ngIf="showCloseButton"
					(click)="onClose()">Close</button>
		</div>
	</ng-template>
</app-si-dialog>
